module.exports = __webpack_public_path__ + "static/media/2H.4b2cf809.jpg";